/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserPrivacySettingsSchema = z.object({
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  showStats: z.optional(z.boolean()),
  showOnlineStatus: z.optional(z.boolean()),
  allowMessages: z.optional(z.boolean()),
  showInSearch: z.optional(z.boolean()),
});
